<ion-header>
  <ion-toolbar>
    <ion-title>Aplicar</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>



      <ng-container>
        <div class="product-section">
          <ion-card-header>
            <ion-card-subtitle class="category">
              {{ getCategoryNameById(product.datos.categ[0]) | uppercase }}
            </ion-card-subtitle>
            <ion-card-title class="product-name">
              {{ product.datos.name | uppercase }}
            </ion-card-title>
            <ion-card-subtitle class="product-qty">
              Cantidad actual:
              <strong>{{ product.datos.qty }}</strong>
              {{ getUmNameById(product.datos.um[0]) }}
            </ion-card-subtitle>
          </ion-card-header>
        </div>

        <div class="quantity-container">  
          <ion-item class="quantity-item">  
            <ion-input
              type="number"    
              [(ngModel)]="extraQty"
              [readonly]="!componentsEnabled"
              inputmode="numeric"
              class="quantity-input">       
            </ion-input>
          </ion-item>
          <div class="quantity-buttons">                                                                                                                                                       
            <ion-button color="medium" expand="block" (click)="clearQty()" [disabled]="!componentsEnabled">
             <!-- <ion-icon slot="icon-only" name="brush-outline"></ion-icon>-->
             0
            </ion-button>
            <ion-button color="primary" expand="block" (click)="addQty(1)" [disabled]="!componentsEnabled">+1</ion-button>
            <ion-button color="success" expand="block" (click)="addQty(10)" [disabled]="!componentsEnabled">+10</ion-button>
          </div>
          <div class="action-buttons-row ion-padding">
            <ion-button color="primary" shape="round" (click)="confirmAction()">
              <ion-icon slot="icon-only" name="checkmark-circle-outline"></ion-icon>
            </ion-button>
          </div>
        </div>

      </ng-container>


</ion-content>
